// @flow
import { basePath } from '../config';

type Options = {};

const config = {
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'text/plain',
    'Content-Language': 'fr_FR'
  }
};

const configPOST = {
  ...config,
  method: 'POST'
};

const configGET = {
  ...config,
  method: 'GET'
};

class SearchAPI {
  static getData(service: string, options?: Options = {}) {
    return fetch(`${basePath}/${service}`, {
      ...configPOST,
      body: JSON.stringify(options)
    }).then(function(response) {
      return new Promise((resolve, reject) => {
        if (response.status === 200) {
          resolve(response.json());
        } else {
          reject(response.statusText);
        }
      });
    });
  }

  static getDocuments(options: Options) {
    return SearchAPI.getData('documents', options);
  }

  static getFacets(options: Options) {
    return SearchAPI.getData('facets', options);
  }

  static getTranslations(options: Options) {
    return SearchAPI.getData('i18n', options);
  }

  static getPermissions(urls: Array<string> = []) {
    return fetch(`${basePath}/permissions?urls=${urls.join(',')}`, {
      ...configGET
    }).then(function(response) {
      return new Promise((resolve, reject) => {
        if (response.status === 200) {
          resolve(response.json());
        } else {
          reject(response.statusText);
        }
      });
    });
  }
}

export default SearchAPI;



// WEBPACK FOOTER //
// ./src/library/SearchAPI.js